module.exports = __webpack_public_path__ + "static/img/11.48544fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/11.png
// module id = 3E1F
// module chunks = 0